import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.OldGeolocationChartView extends Monitoring.Views.Charts.ChartView

  className: 'processing'

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @container = @options.container

  render: ->
    google.load('visualization', '1', { callback: @renderChart, 'packages': ['geochart'] })
    return this

  renderChart: =>
    data = new google.visualization.DataTable()
    data.addColumn "number", "LATITUDE", "Latitude"
    data.addColumn "number", "LONGITUDE", "Longitude"
    data.addColumn "number", "Count", "Count"
    @$el.append($('<div id="geolocationMap"></div>'))

    options =
#      region: 'US'
#      height: "694"
#      width: "1112"
#      resolution: "provinces"
      displayMode: "markers"
      colorAxis: {colors: ['green', 'blue']}

    $.post("/monitoring/api/charts/geolocation", @searchQuery.toJSON(), (response) =>
      @$el.removeClass('processing')

      values = @_parseResponse(response)
      data.addRows(values)

      geomap = new google.visualization.GeoChart(@$el.find('#geolocationMap').get(0))
      geomap.draw(data, options)

      google.visualization.events.addListener(geomap, 'select', (a) =>
        selection = geomap.getSelection()
        lat = data.getValue(selection[0].row, 0)
        lng = data.getValue(selection[0].row, 1)
        geomap.setSelection(null)
        @_previewSearch({ lat: response['top_left'], lng: response['bottom_left'] })
      )
    )


    return this

  settings: ->
    {}

  _previewSearch: (value) ->
    @createPreviewDashboard(@getNewQuery(value))

  getNewQuery: (value) ->
    query = @searchQuery.deepCopy()
#    geo =
#      lat: value.lat,
#      lng: value.lng,
#      radius: 0.000001,
#      unit: 'km'

    geo =
      top_left: value.top_left
      bottom_left: value.bottom_left

    query.setGeolocation(geo)
    return query

  _parseResponse: (response) ->
    _.map(response, (value) -> [value['lat'], value['lon'], value['count']])
